import * as React from 'react';
import { Query } from 'react-apollo';

import UserSMSDeviceView from './UserSMSDeviceView';
import devicesQuery from 'settings/queries/devicesQuery.gql';
import { Devices, Devices_me, Devices_devices } from 'settings/queries/__generated__/Devices';

/* Fetches/renders the current user's first enabled SMS device,
 * falls back to their first disabled/pending SMS device, or
 * shows a null state that allows the user to add a number
 * if they don't have any SMS devices at all.
 */

export type UserSMSDeviceActionButtonAttributes = {
  label: string;
  onClick: (deviceUuid?: string) => void;
  dataTestLabel?: string;
};

export type Props = {
  actionButtonAttributes?: UserSMSDeviceActionButtonAttributes;
};

export default function UserSMSDevice(props: Props) {
  return (
    <Query<Devices> query={devicesQuery}>
      {({ loading, error, data, refetch }) => {
        if (!data) {
          return null;
        }

        return (
          <UserSMSDeviceView
            loading={loading}
            error={error}
            refetch={refetch}
            enabledSMSDevices={getEnabledSMSDevices(data.devices)}
            disabledSMSDevices={getDisabledSMSDevices(data.devices)}
            pendingSMSDevices={getPendingSMSDevices(data.me)}
            actionButtonAttributes={props.actionButtonAttributes}
          />
        );
      }}
    </Query>
  );
}

function getEnabledSMSDevices(devices?: Devices_devices[]) {
  return devices ? devices.filter(device => device.type === 'sms' && device.enabled) : [];
}

function getDisabledSMSDevices(devices?: Devices_devices[]) {
  return devices ? devices.filter(device => device.type === 'sms' && !device.enabled) : [];
}

function getPendingSMSDevices(user?: Devices_me | null) {
  return user ? user.pendingSmsDevices : [];
}
